import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import TextInputTag from "./TextInputTag";

const TextAreaInput = ({ item }) => {
  const { label, name, type, defaultValue, multiple, multipleData, required } =
    item;

  const [quantityCount, setCount] = useState(multipleData);
  const handleAddElement = () => {
    setCount((current) => [
      ...current,
      {
        label: label,
        type: type,
        name: "",
        defaultValue: "",
      },
    ]);
  };

  return (
    <div className="col-span-4 sm:col-span-3 flex flex-row gap-4 items-centers w-full h-full">
      <div className="col-span-2 w-full h-full">
        {multipleData ? (
          quantityCount.map((item, index) => (
            <TextInputTag
              key={index}
              label={label}
              length={index + 1}
              name={name}
              defaultValue={item.defaultValue}
              multiple={multiple}
              required={required}
            />
          ))
        ) : (
          <TextInputTag
            label={label}
            length={0}
            name={name}
            defaultValue={defaultValue}
            multiple={multiple}
            required={required}
          />
        )}
      </div>

      {multiple && (
        <div className="flex justify-center items-end">
          <button
            onClick={handleAddElement}
            type="button"
            className="btn btn-circle"
          >
            <BsPlusLg />
          </button>
        </div>
      )}
    </div>
  );
};

export default TextAreaInput;
